<div class="resizable-widget" [ngClass]="resizable ? 'active' : 'disabled'" (resized)="onResized($event)">
    <div echarts [options]="options" [autoResize]="autoResize" class="echarts"></div>
</div>

